import { css } from '@emotion/react'
import { recordEntries } from 'helpers/records'

export const base = {
  xs: 0,
  algoliaDetached: 680,
  sm: 768,
  md: 992,
  lg: 1280,
  xl: 1440,
  xxl: 1920
}

type Breakpoints = { [P in keyof typeof base]: number }

interface WidthBreakpoints {
  minWidth: Breakpoints
  maxWidth: Breakpoints
}

const breakpoints: WidthBreakpoints = recordEntries(base).reduce(
  (acc, [key, value]) => {
    acc.minWidth[key] = value
    acc.maxWidth[key] = value - 1
    return acc
  },
  {
    minWidth: {},
    maxWidth: {}
  } as Required<WidthBreakpoints>
)

export const media = {
  minWidth: {
    algoliaDetached: `@media (min-width: ${breakpoints.minWidth?.algoliaDetached}px)`,
    xs: `@media (min-width: ${breakpoints.minWidth?.xs}px)`,
    sm: `@media (min-width: ${breakpoints.minWidth?.sm}px)`,
    md: `@media (min-width: ${breakpoints.minWidth?.md}px)`,
    lg: `@media (min-width: ${breakpoints.minWidth?.lg}px)`,
    xl: `@media (min-width: ${breakpoints.minWidth?.xl}px)`,
    xxl: `@media (min-width: ${breakpoints.minWidth?.xxl}px)`
  },
  maxWidth: {
    algoliaDetached: `@media (max-width: ${breakpoints.maxWidth?.algoliaDetached}px)`,
    xs: `@media (max-width: ${breakpoints.maxWidth?.xs}px)`,
    sm: `@media (max-width: ${breakpoints.maxWidth?.sm}px)`,
    md: `@media (max-width: ${breakpoints.maxWidth?.md}px)`,
    lg: `@media (max-width: ${breakpoints.maxWidth?.lg}px)`,
    xl: `@media (max-width: ${breakpoints.maxWidth?.xl}px)`,
    xxl: `@media (max-width: ${breakpoints.maxWidth?.xxl}px)`
  }
}

export const hide = {
  hideSm: css`
    ${media.maxWidth.sm} {
      display: none;
    }
  `,
  hideMd: css`
    ${media.maxWidth.md} {
      display: none;
    }
  `,
  hideLg: css`
    ${media.maxWidth.lg} {
      display: none;
    }
  `,
  hideMinMd: css`
    ${media.minWidth.md} {
      display: none;
    }
  `
}
